var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1728516670237,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 5049,
    width: 128,
    height: 128,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 42.666667a469.333333 469.333333 0 1 0 469.333333 469.333333A469.333333 469.333333 0 0 0 512 42.666667z m0 864a394.666667 394.666667 0 1 1 394.666667-394.666667 395.146667 395.146667 0 0 1-394.666667 394.666667z",
    "p-id": 5050,
    fill: "#fd7e14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M474.666667 695.52m5.333333 0l64 0q5.333333 0 5.333333 5.333333l0 64q0 5.333333-5.333333 5.333334l-64 0q-5.333333 0-5.333333-5.333334l0-64q0-5.333333 5.333333-5.333333Z",
    "p-id": 5051,
    fill: "#fd7e14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M474.666667 253.813333m5.333333 0l64 0q5.333333 0 5.333333 5.333334l0 362.666666q0 5.333333-5.333333 5.333334l-64 0q-5.333333 0-5.333333-5.333334l0-362.666666q0-5.333333 5.333333-5.333334Z",
    "p-id": 5052,
    fill: "#fd7e14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.cb16373c7ebbae97735d6e844b02eeec.svg";
export { ForwardRef as ReactComponent };